/*
 * Copyright (c) 2022 EGT Digital - All rights reserved.
 *
 * File: Clock.tsx
 *
 * Written by Martin Lubenov <martin.lubenov@egt-digital.com> on  31.10.22 11:46 am.
 * Last modified: 31.10.22 11:46 am.
 *
 * More information at: https://egt-digital.com/
 */
import React, { useEffect, useState } from 'react';
import { getTimeComponents } from '../api/helpers';

const Clock = () => {
    const date: any = new Date();
    const { hours, minutes } = getTimeComponents(date);

    const [clockHours, setClockHours] = useState(hours);
    const [clockMinutes, setClockMinutes] = useState(minutes);

    useEffect(() => {
        const interval = setInterval(() => {
            const dateInner = new Date();
            const { hours: h, minutes: m } = getTimeComponents(dateInner);

            setClockHours(h);
            setClockMinutes(m);
        }, 10000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <div className="egt_lobby_clock">
            {clockHours}:{clockMinutes}
        </div>
    );
};

export default Clock;
